module.exports = __webpack_public_path__ + "img/46.960c0f83.png";